import { Box, ListItemIcon, ListItemText } from "@mui/material";
import React from "react";
import { UserIcon } from "../../components/Primitives";
import { useAuthContext } from "../../providers/Auth/auth.provider";
import { useSidebarStyle } from "../../style/sidebar.style";

export const SidebarUserMenu: React.VFC = () => {
  const { internalUser } = useAuthContext();
  const { classes } = useSidebarStyle();

  return (
    <Box
      className={classes.userInfoContainer}
      id="user-menu"
      key="user-menu"
    >
      <ListItemIcon className={classes.listItemIcon}>
        <UserIcon svgColor="green" />
      </ListItemIcon>
      <ListItemText primary={internalUser?.fullName} className={classes.userInfoText} />
    </Box>
  );
};
